import { gSSP } from "app/server/gSSP"
import { getSessionContext as getSession } from "app/auth/session"
import { Routes } from "app/routes"
import { PageWithLayout } from "app/types"
import LoginLayout from "app/core/layouts/LoginLayout"
import { LoginForm } from "app/auth/components/LoginForm"
import React from "react"
import getMostSuitableDashboard from "app/dashboards/queries/getMostSuitableDashboard"
import { useRouter } from "next/router"

export const getServerSideProps = gSSP(async ({ ctx, query, req, res }) => {
  // Server-side redirect prevents flash of invalid content
  const session = await getSession(req, res)
  if (session.userId) {
    if (!query.next && !session.landingPage) {
      const mostSuitableDashboard = await getMostSuitableDashboard({}, ctx)
      if (mostSuitableDashboard) {
        return {
          redirect: {
            destination: Routes.DashboardViewer({
              dashboardId: mostSuitableDashboard.dashboard.id,
            }),
            permanent: false,
          },
        }
      }
    }

    return {
      redirect: {
        destination: session.landingPage ?? Routes.MyTeamsPage(),
        permanent: false,
      },
    }
  }
  return { props: {} }
})

const LoginPage: PageWithLayout = () => {
  const router = useRouter()

  return (
    <div className="mt-auto mb-auto">
      <LoginForm
        onSuccess={() => {
          let next: string | undefined = undefined
          if (!!router.query.next && !Array.isArray(router.query.next)) {
            const candidate = router.query.next
            if (candidate.startsWith("/") && !candidate.startsWith("//")) {
              next = candidate
            }
          }
          return router.push(next ?? Routes.Home())
        }}
      />
    </div>
  )
}

LoginPage.getLayout = (page) => <LoginLayout title="Log In">{page}</LoginLayout>

export default LoginPage
